import { Component, OnInit, signal } from '@angular/core';
import { ContentfulService } from '../contentful/contentful.service';
import { formatPhone, phoneHref } from '../contacts/phone';

interface ContactsFields {
  name: string;
  phones?: string[];
}

@Component({
  selector: 'app-contacts-footer',
  templateUrl: './contacts-footer.component.html',
  styleUrl: './contacts-footer.component.scss',
})
export class ContactsFooterComponent implements OnInit {
  readonly currentYear = new Date().getFullYear();
  readonly formatPhone = formatPhone;
  readonly phoneHref = phoneHref;
  phones = signal<string[]>([]);

  constructor(private readonly contentfulService: ContentfulService) {}

  ngOnInit(): void {
    this.contentfulService
      .getEntries<ContactsFields>({
        contentType: 'contacts',
        query: { 'fields.name': 'Roma' },
        limit: 1,
      })
      .subscribe({
        next: (res) => {
          const entry = res.items[0];
          if (entry) this.phones.set(entry.fields.phones ?? []);
        },
      });
  }
}
